<template>
    <!-- profile card -->
            <div class="col-3 left">
              <div class="profile_info">
                <div class="seller-card">
                  <div>
                    <div
                      class="user-online-indicator is-online"
                      data-user-id="1152855"
                    >
                      <i class="fa fa-circle"></i>online
                    </div>
                  </div>
                  <div>
                    <a href="#" class="ambassadors-badge">Beneficiary</a>
                  </div>
                  <div class="user-profile-info">
                    <div>
                      <div class="user-profile-image">
                        <label class="user-pict">
                          <img
                            src="@/assets/images/profile.png"
                            class="img-fluid user-pict-img"
                            alt="Askbootstrap" />
                          <a
                            href="#"
                            class="user-badge-round user-badge-round-med locale-en-us top-rated-seller"
                          ></a
                        ></label>
                      </div>
                    </div>
                    <div class="user-profile-label">
                      <div class="username-line">
                        <a href="#" class="seller-link">Gloria Amaka</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="seller-profile">
                <div class="description">
                  <h3>Description</h3>
                  <p>
                    I am a Artificial Intelligence Trainee from Nigeria. I like everything
                    from video games to phone systems to explainer videos to
                    children's books. I am originally from the South East of
                    Nigeria.
                  </p>
                  <p class="">Country: <strong>Nigeria</strong></p>
                </div>
              </div>
            </div>
            <!-- end profile card -->
</template>

<script>
export default {
  name: "miniProfile"
}
</script>

<style>

</style>